import { Loader2, X } from "lucide-react";
import { ButtonFluxi } from "../../common/Buttons/ButtonFluxi/ButtonFluxi";
import { dictionary, Language } from "../../../utils/dictionary";
import { isProduction } from "../../../config/environment";

interface ModalMercadoPagoIntegrationProps {
    id: string;
    setModalOpenMercadoPago: (open: boolean) => void;
    handlePostMercadoPagoIntegration: (tokenPublic: string, tokenPrivate: string, id: string) => void;
    tokenPublic: string;
    setTokenPublic: (token: string) => void;
    tokenPrivate: string;
    setTokenPrivate: (token: string) => void;
    loading: boolean;
    language: Language;
}

const isTestToken = (token: string): boolean => {
    return token.startsWith("TEST-");
};

const ModalMercadoPagoIntegration = ({ id, setModalOpenMercadoPago, handlePostMercadoPagoIntegration, tokenPublic, setTokenPublic, tokenPrivate, setTokenPrivate, loading, language }: ModalMercadoPagoIntegrationProps) => {

    const hasTestToken = isProduction && (isTestToken(tokenPublic) || isTestToken(tokenPrivate));

    return (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center p-4">
            <div className="bg-white p-4 md:p-6 rounded-lg shadow-xl w-full max-w-md flex flex-col items-center justify-center relative max-h-[90vh] overflow-y-auto">
                <button className="absolute top-3 md:top-4 right-3 md:right-4 z-10" onClick={() => setModalOpenMercadoPago(false)}>
                    <X className="w-5 h-5 md:w-6 md:h-6" />
                </button>
                <div className="flex flex-col items-center justify-center gap-4 w-full max-w-[225px] h-[80px] md:h-[100px] mt-2">
                    <img src="https://http2.mlstatic.com/frontend-assets/mp-web-navigation/ui-navigation/6.7.73/mercadopago/logo__large@2x.png" alt="Mercado Pago" className="w-full h-auto object-contain" />
                </div>
                <div className="flex flex-col items-center justify-center gap-4 w-full mt-4">
                    <div className="flex flex-col items-start justify-center gap-2 w-full">
                        <p className="text-xs md:text-sm text-gray-500 font-bold">{dictionary["public-token"][language]}:</p>
                        <textarea 
                            name="" 
                            id="" 
                            className="w-full h-[80px] md:h-[100px] border border-gray-300 rounded-lg p-2 text-sm md:text-base resize-none" 
                            placeholder={dictionary["enter-your-public-token"][language]} 
                            value={tokenPublic} 
                            onChange={(e) => setTokenPublic(e.target.value)}
                        ></textarea>
                    </div>
                    <div className="flex flex-col items-start justify-center gap-2 w-full">
                        <p className="text-xs md:text-sm text-gray-500 font-bold">{dictionary["private-token"][language]}:</p>
                        <textarea 
                            name="" 
                            id="" 
                            className="w-full h-[80px] md:h-[100px] border border-gray-300 rounded-lg p-2 text-sm md:text-base resize-none" 
                            placeholder={dictionary["enter-your-private-token"][language]} 
                            value={tokenPrivate} 
                            onChange={(e) => setTokenPrivate(e.target.value)}
                        ></textarea>
                    </div>
                </div>
                {hasTestToken && (
                    <p className="text-xs text-red-500 mt-2 w-full text-left">
                        {dictionary["test-tokens-not-allowed-in-production"][language]}
                    </p>
                )}
                <div className="flex flex-col items-center justify-center gap-4 w-full mt-4">
                    <ButtonFluxi
                        disabled={tokenPublic === "" || tokenPrivate === "" || loading || hasTestToken}
                        onClick={() => handlePostMercadoPagoIntegration(tokenPublic, tokenPrivate, id)}
                        style={{ width: "100%" }}
                    >
                        {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : dictionary["connect"][language]}
                    </ButtonFluxi>
                </div>
            </div>
        </div>
    );
};

export default ModalMercadoPagoIntegration;